/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
  (function () {
    var tabs = document.querySelectorAll('.pf-tab-btn');
    var panels = document.querySelectorAll('.pf-tab-panel');

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.dataset.tab;

        tabs.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('active');
        });

        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        var panel = document.getElementById('pf-tab-' + target);
        if (panel) panel.classList.add('active');
      });

      // Keyboard navigation
      btn.addEventListener('keydown', function (e) {
        var tabArr = Array.from(tabs);
        var idx = tabArr.indexOf(this);
        if (e.key === 'ArrowRight' && idx < tabArr.length - 1) {
          tabArr[idx + 1].focus(); tabArr[idx + 1].click();
        }
        if (e.key === 'ArrowLeft' && idx > 0) {
          tabArr[idx - 1].focus(); tabArr[idx - 1].click();
        }
        if (e.key === 'Home') {
          tabArr[0].focus(); tabArr[0].click();
        }
        if (e.key === 'End') {
          tabArr[tabArr.length - 1].focus(); tabArr[tabArr.length - 1].click();
        }
      });
    });
  })();

/* Start Best Before Date */
  function initBBDCheckbox() {
    const checkbox = document.getElementById('agree-checkbox');
    const warning = document.getElementById('checkbox-warning');
    const confirmationProp = document.getElementById('confirmation-property');
    const confirmedTime = document.getElementById('confirmed-time');

    const productForm = document.querySelector('form[action="/cart/add"]');
    const addToCartBtn = productForm ? productForm.querySelector('button[type="submit"]') : null;

    if (!checkbox || !addToCartBtn) return;

    // ✅ Function to update button state
    function updateButtonState() {
      if (checkbox.checked) {
        addToCartBtn.disabled = false;
        addToCartBtn.style.opacity = '1';
        addToCartBtn.style.cursor = 'pointer';
        addToCartBtn.title = '';
        warning.style.display = 'none';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.style.opacity = '0.5';
        addToCartBtn.style.cursor = 'not-allowed';
        addToCartBtn.title = 'Please confirm the checkbox first';
      }
    }

    // 🔁 Run immediately on load (THIS FIXES YOUR ISSUE)
    updateButtonState();

    // ✅ Handle checkbox change
    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        const now = new Date();
        const timestamp = now.toLocaleString('en-CA', { 
          timeZone: 'America/Toronto',
          dateStyle: 'medium', 
          timeStyle: 'short' 
        });

        confirmationProp.value = "✅ YES - Customer Confirmed";
        confirmedTime.value = timestamp + " (EST)";
      } else {
        confirmationProp.value = "❌ NOT Confirmed";
        confirmedTime.value = "Not confirmed";
      }

      updateButtonState();
    });

    // 🚫 Block submission if unchecked
    productForm.addEventListener('submit', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        warning.style.display = 'block';
        checkbox.focus();
        return false;
      }
    }, true);
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', initBBDCheckbox);

  // Shopify dynamic reload fix
  document.addEventListener('shopify:section:load', initBBDCheckbox);
  document.addEventListener('shopify:variant:change', initBBDCheckbox);

  /* End Best Before Date */

  /* Start Heat Sensitive */  
(function() {
  var heatCheckbox = document.getElementById('agree-checkbox-heat');
  if (!heatCheckbox) return;

  var confirmProp = document.getElementById('confirmation-property-heat');
  var timeProp = document.getElementById('confirmed-time-heat');
  var warning = document.getElementById('checkbox-warning-heat');

  // Force reset on every page load including back/forward navigation
  window.addEventListener('pageshow', function() {
    heatCheckbox.checked = false;
    confirmProp.value = '❌ NOT Confirmed';
    timeProp.value = 'Not confirmed';
    warning.style.display = 'none';
  });

  heatCheckbox.addEventListener('change', function() {
    if (this.checked) {
      confirmProp.value = '✅ Confirmed';
      timeProp.value = new Date().toLocaleString();
      warning.style.display = 'none';
    } else {
      confirmProp.value = '❌ NOT Confirmed';
      timeProp.value = 'Not confirmed';
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"], button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    if (!heatCheckbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      warning.style.display = 'block';
      heatCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

})();
 /* End Heat Sensitive */ 

  /* Start Best Before Date Confirmation */
(function() {
  var bbdCheckbox = document.getElementById('agree-checkbox-bbd');
  if (!bbdCheckbox) return;

  var confirmProp = document.getElementById('confirmation-property-bbd');
  var timeProp = document.getElementById('confirmed-time-bbd');
  var warning = document.getElementById('checkbox-warning-bbd');

  // Force reset on every page load including back/forward navigation
  window.addEventListener('pageshow', function() {
    bbdCheckbox.checked = false;
    confirmProp.value = '❌ NOT Confirmed';
    timeProp.value = 'Not confirmed';
    warning.style.display = 'none';
  });

  bbdCheckbox.addEventListener('change', function() {
    if (this.checked) {
      confirmProp.value = '✅ Confirmed';
      timeProp.value = new Date().toLocaleString();
      warning.style.display = 'none';
    } else {
      confirmProp.value = '❌ NOT Confirmed';
      timeProp.value = 'Not confirmed';
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"], button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    if (!bbdCheckbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      warning.style.display = 'block';
      bbdCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

})();
  /* End Best Before Date Confirmation */

  /* Start Ship At Own Risk Confirmation */
(function() {
  var riskCheckbox = document.getElementById('agree-checkbox-risk');
  if (!riskCheckbox) return;

  var confirmProp = document.getElementById('confirmation-property-risk');
  var timeProp = document.getElementById('confirmed-time-risk');
  var warning = document.getElementById('checkbox-warning-risk');

  // Force reset on every page load including back/forward navigation
  window.addEventListener('pageshow', function() {
    riskCheckbox.checked = false;
    confirmProp.value = '❌ NOT Confirmed';
    timeProp.value = 'Not confirmed';
    warning.style.display = 'none';
  });

  riskCheckbox.addEventListener('change', function() {
    if (this.checked) {
      confirmProp.value = '✅ Confirmed';
      timeProp.value = new Date().toLocaleString();
      warning.style.display = 'none';
    } else {
      confirmProp.value = '❌ NOT Confirmed';
      timeProp.value = 'Not confirmed';
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"], button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    if (!riskCheckbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      warning.style.display = 'block';
      riskCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

})();
/* End Ship At Own Risk Confirmation */


